<template>
  <div class="container profile-view">
    <div class="notification is-info">
      <h3 class="title">Billing Portal</h3>
      <p>
        This window will now close and you will be redirected to the ShareDocView app.
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BillingPortalClose',
  data() {
    return {};
  },
  created() {
    window.close();
  }
};
</script>
